module.exports = __webpack_public_path__ + "img/wyslij_kurs.0d9732cc.svg";